import { render } from "./PercentIcon.vue?vue&type=template&id=4a333ae6"
import script from "./PercentIcon.vue?vue&type=script&lang=js"
export * from "./PercentIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__